import { render, staticRenderFns } from "./FrameworkStep.vue?vue&type=template&id=59c138e0&"
import script from "./FrameworkStep.vue?vue&type=script&lang=js&"
export * from "./FrameworkStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports